import { APP_VERSION } from '@lmt/unicorn-shared/app/constants/constants';
import { InternalAxiosRequestConfig } from 'axios';

function createId() {
  return Math.random().toString(36).substr(2, 9);
}

// it's constant while the app is running, and different after app restarts
export const sessionId = `${createId()}-${createId()}-${createId()}`;

/**
 * Intercepts all HTTP calls via axios and adds a session-id header.
 */
export function sessionAxiosInterceptor(config: InternalAxiosRequestConfig) {
  config.headers = config.headers ?? {};
  config.headers['ClientSession'] = sessionId;
  config.headers['ClientVersion'] = APP_VERSION;
  config.headers['ClientPlatform'] = 'web';
  return config;
}
